import { useSyncExternalStore } from 'react'
import { pushLocation, subscribeLocation } from './timelineFilters'

export const EVENT_TABS = ['orders', 'attendees', 'waitlist', 'settings'] as const
export type EventTab = (typeof EVENT_TABS)[number]

/** The event page's tab lives in `?tab=` on the event's canonical address, so a reload keeps it. */
export function useEventTab(eventId: number, availableTabs: readonly EventTab[]) {
  const requested = useSyncExternalStore(subscribeLocation, () =>
    new URLSearchParams(window.location.search).get('tab'),
  )
  const activeTab: EventTab = availableTabs.find((tab) => tab === requested) ?? 'orders'
  const setActiveTab = (tab: string) => {
    const url = new URL(window.location.href)
    url.pathname = `/events/manage/${eventId}`
    if (tab === 'orders') url.searchParams.delete('tab')
    else url.searchParams.set('tab', tab)
    pushLocation(url)
  }
  return [activeTab, setActiveTab] as const
}
